import React, { FC } from "react";
import { Box, BoxProps } from "theme-ui";
import { KameleonIcon } from "@kameleon-common/icons";

export type IconTertiaryType = BoxProps & {
  icon: string;
};

export const IconTertiary: FC<IconTertiaryType> = ({
  icon,
  ...props
}: IconTertiaryType) => (
  <Box {...props} variant="icons.tertiary">
    <KameleonIcon name={icon} />
  </Box>
);
